module.exports = __webpack_public_path__ + "img/userB02.d9f2f536.jpg";